var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMosanLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 80,
    viewBox: "0 0 83 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 40C71 57.1208 57.1208 71 40 71C27.5116 71 16.7479 63.6154 11.8375 52.9746L28.6364 35.9091L37.2727 53.6364L57.2727 34.5454L53.1818 56.8182L69.3597 30.0235C70.4232 33.1542 71 36.5098 71 40ZM65.207 21.9514L40.9091 40.9091L25.4545 21.8182L10.0356 47.9754C9.36 45.4306 9 42.7574 9 40C9 22.8792 22.8792 9 40 9C50.3875 9 59.5818 14.109 65.207 21.9514ZM72.3077 16.4112C65.0312 6.46213 53.2703 0 40 0C17.9086 0 0 17.9086 0 40C0 46.4223 1.51356 52.4911 4.20343 57.8692L0 65L5.19326 59.7243C12.0694 71.8322 25.0808 80 40 80C62.0914 80 80 62.0914 80 40C80 32.9819 78.1926 26.3859 75.0179 20.6522L82.2727 8.63635L72.3077 16.4112Z",
    fill: "url(#paint0_linear_181_6770)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_6770",
    x1: 41.1364,
    y1: 0,
    x2: 41.1364,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosanLogo);
export default __webpack_public_path__ + "static/media/mosan_logo.3f085555cf869408a890615db7578af5.svg";
export { ForwardRef as ReactComponent };